import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { animeListsApi } from './api/store/anime-lists'
import {listedAnimeApi} from "./api/store/listed-anime";
import {settingsApi} from "./api/store/settings";
import {listModalSlice} from "./slices/listModalSlice";
import {newAnimeModalSlice} from "./slices/newAnimeModalSlice";
import {genresApi} from "./api/store/genres";
import {animeApi} from "./api/store/anime";
import {seasonsApi} from "./api/store/seasons";
import {showNavSlice} from "./slices/showNavSlice";
import {sharedAnimeListsApi} from "./api/store/shared-anime-list";
import {sharedListedAnimeApi} from "./api/store/shared-listed-anime";
import {userApi} from "./api/store/users";
import {feedbackApi} from "./api/store/feedback";

export const store = configureStore({
    reducer: {
        [animeListsApi.reducerPath]: animeListsApi.reducer,
        [listedAnimeApi.reducerPath]: listedAnimeApi.reducer,
        [settingsApi.reducerPath]: settingsApi.reducer,
        [genresApi.reducerPath]: genresApi.reducer,
        [animeApi.reducerPath]: animeApi.reducer,
        [seasonsApi.reducerPath]: seasonsApi.reducer,
        [sharedAnimeListsApi.reducerPath]: sharedAnimeListsApi.reducer,
        [sharedListedAnimeApi.reducerPath]: sharedListedAnimeApi.reducer,
        [userApi.reducerPath]: userApi.reducer,
        [feedbackApi.reducerPath]: feedbackApi.reducer,
        "isListModalOpen": listModalSlice.reducer,
        "isNewAnimeModalOpen": newAnimeModalSlice.reducer,
        "showNav": showNavSlice.reducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            .concat(animeListsApi.middleware)
            .concat(listedAnimeApi.middleware)
            .concat(settingsApi.middleware)
            .concat(genresApi.middleware)
            .concat(animeApi.middleware)
            .concat(seasonsApi.middleware)
            .concat(sharedAnimeListsApi.middleware)
            .concat(sharedListedAnimeApi.middleware)
            .concat(userApi.middleware)
            .concat(feedbackApi.middleware)
})


setupListeners(store.dispatch);